import React, { useEffect, useState } from 'react';
import {
  Flex,
  Box,
  Text,
  Input,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@chakra-ui/react';
import ChakraMarkdown from '../components/ChakraMarkdown';
import Layout from '../components/Layout';
import Seo from '../components/Seo';
import { useQuery } from '@apollo/client';
import { GET_SUPPORT_QUESTIONS } from '../apollo/queries/GetSupportQuestions';

const Support = ({ global }) => {
  const questionOrder = [
    'What is a briefing?',
    'How do you create a briefing?',
    'How do you save and edit a briefing?',
    'What are the different versions of briefings?',
    'What is a keyword search?',
    'What is a semantic search?',
    'How do you create briefings in different languages?',
    'How do you train a briefing?',
    'How do you create site allowlists/blocklists?',
    'How do you use allow and block lists in a briefing?',
    "How do you access all your team's briefings?",
    "What is a team's settings tab?",
    'How do you add a user to a team?',
    'How do you accept an invite to a team/organization?',
    "What is an organization's settings tab?",
    'How do you add a user to an organization?',
    'How do you access and interpret the usage analytics?',
    'How do you use the Anders Pink Chrome extension?',
    'How do you get my briefings/folders CSV Export and RSS Feed?',
    'What are saved folders and how do they work?',
    'How do you make my briefings/folders publicly accessible?',
    'How do you use the search?',
    'How do you create Web Content Filters?',
    'How do you access the API?',
  ];

  const [questions, setQuestions] = useState([]);
  const [filteredQuestions, setFilteredQuestions] = useState(questionOrder);
  const [currentCategory, setCurrentCategory] = useState('Web Curation (New)');
  const [currentQuestion, setCurrentQuestion] = useState(null);

  const { data, error, loading } = useQuery(GET_SUPPORT_QUESTIONS, {
    context: { clientName: 'strapi' },
    variables: {
      pagination: {
        page: 1,
        pageSize: 1000,
      },
      filters: {
        category: { eq: currentCategory },
      },
    },
    fetchPolicy: 'cache-first',
  });

  useEffect(() => {
    if (!loading) {
      setQuestions(data.faqs.data);
    }
  }, [data, loading]);

  const handleSearch = (e) => {
    let questions = questionOrder.filter((q) =>
      q.toLowerCase().includes(e.target.value)
    );

    setFilteredQuestions(questions);
  };

  const handleLinkClick = (event) => {
    event.preventDefault();
    const url = event.target.href;

    const searchString = decodeURIComponent(url.split('#')[1]);

    const index = questionOrder.findIndex(
      (question) => question === searchString
    );

    if (index !== currentQuestion) {
      setCurrentQuestion(index);
    }
  };

  return (
    <Layout global={global}>
      <Seo seo={{}} />
      <Flex
        direction="column"
        justifyContent="center"
        alignItems="center"
        my="4rem"
      >
        <Flex
          alignItems="center"
          direction="column"
          w="100%"
          marginBottom={'2rem'}
        >
          <Text mb={4} fontSize="1.25rem" lineHeight="1.7">
            Watch the demo of the new Web Curation app
          </Text>
          <Box width={'40rem'}>
            <div
              style={{
                position: 'relative',
                paddingBottom: '53.465346534653456%',
                height: 0,
              }}
            >
              <iframe
                src="https://www.loom.com/embed/42f3bee4af104088b8d0ab6f73e69d56?sid=0d16c9a3-4be8-4465-8425-6141b5451e03"
                allowFullScreen
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                }}
              ></iframe>
            </div>
          </Box>
        </Flex>
        <Text fontSize="1.25rem" lineHeight="1.7">
          How can we help you?
        </Text>
        <Box
          w="100%"
          backgroundColor="gray.100"
          margin={'2rem auto'}
          justifyContent="center"
          alignItems="center"
          textAlign="center"
        >
          <Input
            maxW={720}
            my={10}
            placeholder="Search for a question"
            backgroundColor="white"
            onChange={(e) => handleSearch(e)}
          />
        </Box>

        <Box w="100%" py={5}>
          <Box maxW={720} margin={'1rem auto'}>
            <Tabs
              onChange={(index) => {
                if (index === 0) {
                  setCurrentCategory('Web Curation (New)');
                  setCurrentQuestion(null);
                }
                // if (index === 1) {
                //   setCurrentCategory('Web Curation');
                //   setCurrentQuestion(null);
                // }
              }}
            >
              <TabList>
                <Tab color="black">Web Curation</Tab>
              </TabList>

              <TabPanels>
                <TabPanel>
                  <Accordion allowToggle index={currentQuestion}>
                    {filteredQuestions.map((question, index) => {
                      const item = questions.find(
                        (item) => item.attributes.question === question
                      );

                      return (
                        <AccordionItem key={index}>
                          <h2>
                            <AccordionButton
                              onClick={() => {
                                if (index === currentQuestion) {
                                  setCurrentQuestion(null);
                                } else {
                                  setCurrentQuestion(index);
                                }
                              }}
                            >
                              <Box
                                as="span"
                                flex="1"
                                textAlign="left"
                                fontSize="0.9rem"
                                fontWeight="600"
                              >
                                {question}
                              </Box>
                              <AccordionIcon />
                            </AccordionButton>
                          </h2>
                          <AccordionPanel pb={4}>
                            <ChakraMarkdown
                              content={item?.attributes.answer || ''}
                              onLinkClick={handleLinkClick}
                            />
                          </AccordionPanel>
                        </AccordionItem>
                      );
                    })}
                  </Accordion>
                </TabPanel>
                <TabPanel>
                  <Accordion allowToggle index={currentQuestion}>
                    {questions.map((item, index) => (
                      <AccordionItem key={index}>
                        <h2>
                          <AccordionButton
                            onClick={() => {
                              if (index === currentQuestion) {
                                setCurrentQuestion(null);
                              } else {
                                setCurrentQuestion(index);
                              }
                            }}
                          >
                            <Box
                              as="span"
                              flex="1"
                              textAlign="left"
                              fontSize="0.9rem"
                              fontWeight="600"
                            >
                              {item.attributes.question}
                            </Box>
                            <AccordionIcon />
                          </AccordionButton>
                        </h2>
                        <AccordionPanel pb={4}>
                          <ChakraMarkdown
                            content={item.attributes.answer}
                            onLinkClick={handleLinkClick}
                          />
                        </AccordionPanel>
                      </AccordionItem>
                    ))}
                  </Accordion>
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Box>
        </Box>
      </Flex>
    </Layout>
  );
};

export default Support;
